import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toggle from 'react-bootstrap-toggle';
import { first } from 'lodash';

import masterField from './master-field';

class BooleanField extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.toggle = this.toggle.bind(this);
  }

  toggle(v) {
    const { path } = this.props;
    this.props.onUpdate(path, { values: [v] });
  }

  render() {
    const { searchCriteria, disabled, readOnly } = this.props;
    const values = searchCriteria.values || [];
    const value = first(values);
    if (readOnly) {
      return (
        <strong className={`text-uppercase ${(value === true ? 'text-success' : 'text-danger')}`}>
          {(value === true ? 'YES' : 'NO')}
        </strong>
      );
    }
    return (
      <div style={{ paddingTop: '4px' }}>
        <Toggle
          onClick={this.toggle}
          on={<span>YES</span>}
          off={<span>No</span>}
          disabled={disabled}
          size="xs"
          onstyle="success"
          active={value === true}
        />
      </div>
    );
  }
}
function mapStateToProps() {
  return {};
}

BooleanField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchCriteria: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    filter: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  }),
  onUpdate: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};
BooleanField.defaultProps = {
  searchCriteria: null,
  disabled: false,
  readOnly: false,
};


export default masterField(connect(mapStateToProps)(BooleanField));
